import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowRight = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.29289 19.7072C6.90237 19.3167 6.90237 18.6835 7.29289 18.293L13.5858 12.0001L7.29289 5.70711C6.90237 5.31658 6.90237 4.68342 7.29289 4.29289C7.68342 3.90237 8.31658 3.90237 8.70711 4.29289L15.7072 11.293C16.0977 11.6835 16.0977 12.3166 15.7072 12.7072L8.70711 19.7072C8.31658 20.0978 7.68342 20.0978 7.29289 19.7072Z", fill: color }));
};
export default factorySvgIcon(SvgArrowRight);
//# sourceMappingURL=SvgArrowRight.js.map